import vuex from '@/store'

export default {
  shortInstruction(instructions) {
    const text = instructions.replace(/<\/?[^>]+(>|$)/g, "");
    const short = text.substring(0, 200).trim()
    return short + '...'
  },
  removeUnnecessaryIngredients(ingredients) {
    return ingredients.filter(ingredient => {
      return !ingredient.includes('personer') && !ingredient.includes('serveringer')
    })
  },
  orderRecipeBy(recipes, orderBy) {
    let orderedRecipes;
    const favoriteIds = vuex.getters.getFavorites;
    const doneIds = vuex.getters.getDone;
    switch (orderBy) {
      case 'new': orderedRecipes = recipes.sort((a, b) => new Date(b.Created) - new Date(a.Created))
        break;
      case 'old': orderedRecipes = recipes.sort((a, b) => new Date(a.Created) - new Date(b.Created))
        break;
      case 'az':
        orderedRecipes = recipes.sort((a, b) => a.Title.localeCompare(b.Title))
        break;
      case 'za':
        orderedRecipes = recipes.sort((a, b) => b.Title.localeCompare(a.Title))
        break;
      case 'done':
        orderedRecipes = recipes.filter(recipe => doneIds.includes(recipe.Id.toString()))
        break;
      case 'favorite':
        orderedRecipes = recipes.filter(recipe => favoriteIds.includes(recipe.Id.toString()))
        break;
      case 'random':
        orderedRecipes = recipes.sort(() => Math.random() < 0.5 ? -1 : 1)
        break;
      default:
        break;
    }
    return orderedRecipes;
  },
  removeHtml(html) {
    // We split instructions on <br />. Replace it with a sentinel up front so
    // that, after we strip unwanted tags, the line breaks survive.
    html = html.replace(/\u00A0/g, '')
    html = html.replace(/<br \/>/g, "|||");
    html = html.replace(/(?:\r\n|\r|\n)/g, '|||');

    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;

    // Keep emphasis AND list structure (b/i/strong/em + ul/ol/li). Anything
    // else gets unwrapped to plain text. Lists are kept because instructions
    // and notes need to render bullets.
    const allowedTags = ['b', 'i', 'strong', 'em', 'ul', 'ol', 'li'];
    const allElements = tmp.querySelectorAll('*');

    allElements.forEach(el => {
      const tagName = el.tagName.toLowerCase();

      if (allowedTags.includes(tagName)) {
        while (el.attributes.length > 0) {
          el.removeAttribute(el.attributes[0].name);
        }
      } else {
        while (el.firstChild) {
          el.parentNode.insertBefore(el.firstChild, el);
        }
        el.remove();
      }
    });

    html = tmp.innerHTML;

    // Split first, keep empties so we can tell when there was a full
    // paragraph break in the source HTML between two chunks.
    const rawChunks = html.split('|||').map(c => c.trim());

    // Merge a list-starting chunk into the previous chunk ONLY when the
    // previous chunk was non-empty AND there was no empty chunk between.
    //   "Step 1<br /><ul>...</ul>"          -> ["Step 1", "<ul>..."]
    //     no empty chunk between -> merge   -> ["Step 1<ul>..."]
    //   "Step 1<br /><br /><ul>...</ul>"    -> ["Step 1", "", "<ul>..."]
    //     empty chunk between   -> keep    -> ["Step 1", "<ul>..."]
    // The first case is Shift+Enter (line break, attach the list to the
    // previous step). The second is a full Enter (paragraph break, the
    // list should be its own step).
    const merged = [];
    let sawBreak = false;
    for (const chunk of rawChunks) {
      if (chunk === '') {
        sawBreak = true;
        continue;
      }
      const startsWithList = /^<(ul|ol)\b/i.test(chunk);
      if (startsWithList && !sawBreak && merged.length > 0) {
        merged[merged.length - 1] += chunk;
      } else {
        merged.push(chunk);
      }
      sawBreak = false;
    }

    // Drop chunks that, after HTML parsing, contain no actual text.
    return merged.filter(chunk => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = chunk;
      return (tempDiv.textContent || tempDiv.innerText || '').trim().length > 0;
    });
  }
}